const rules = new Intl.PluralRules('ru');

export const plural = (
  value: number,
  suffixes: Record<Intl.LDMLPluralRule, string>,
): string => {
  const rule = rules.select(value);

  return suffixes[rule];
};
